import React from 'react';
import { motion } from 'framer-motion';
import { CrownIcon, CalendarIcon, TargetIcon, TrendingUpIcon } from 'lucide-react';
const premiumBonuses = [{
  icon: CalendarIcon,
  title: 'Calendario Financiero de 12 Meses',
  desc: 'Planificá todo tu año financiero.'
}, {
  icon: TargetIcon,
  title: 'Planificador de Objetivos Económicos',
  desc: 'Convertí metas financieras en resultados concretos.'
}, {
  icon: TrendingUpIcon,
  title: 'Sistema $100.000 Extra',
  desc: 'Estrategias prácticas para generar ingresos adicionales.'
}];
export function KitProPremium() {
  return <section className="py-14 md:py-20 relative overflow-hidden" data-id="element-147">
      <div className="absolute inset-0 bg-[#0c0a05]" data-id="element-148" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[400px] md:h-[600px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-149" />

      <div className="container mx-auto px-5 md:px-6 relative z-10" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-151">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gold/10 border border-gold/20 mb-4 md:mb-6" data-id="element-152">
            <CrownIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold" data-id="element-153" />
            <span className="text-[11px] md:text-sm font-bold tracking-wide text-gold uppercase" data-id="element-154">
              Exclusivo
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl mb-3 md:mb-5" data-id="element-155">
            KIT PRO —{' '}
            <span className="text-gold italic" data-id="element-156">3 BONUS PLUS PREMIUM</span>
          </h2>
          <p className="text-sm md:text-xl text-gold/70" data-id="element-157">
            Llevá tu organización al siguiente nivel con herramientas avanzadas
            de planificación.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-5 max-w-5xl mx-auto" data-id="element-158">
          {premiumBonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.12
          }} whileHover={{
            y: -3
          }} className="bg-surface/50 backdrop-blur-sm rounded-2xl p-5 md:p-7 border border-gold/20 hover:border-gold/50 transition-all group relative overflow-hidden" data-id="element-159">
                <div className="absolute inset-0 bg-gradient-to-br from-gold/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-160" />

                <div className="flex justify-between items-center mb-4 md:mb-5 relative z-10" data-id="element-161">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-2xl bg-gold/10 flex items-center justify-center border border-gold/20" data-id="element-162">
                    <Icon className="w-5 h-5 md:w-6 md:h-6 text-gold" data-id="element-163" />
                  </div>
                  <span className="text-[10px] md:text-xs font-bold tracking-widest text-gold/50 uppercase" data-id="element-164">
                    Bonus Plus {i + 1}
                  </span>
                </div>

                <h3 className="text-base md:text-xl font-serif text-white mb-2 relative z-10 leading-tight" data-id="element-165">
                  {bonus.title}
                </h3>
                <p className="text-xs md:text-sm text-text-muted relative z-10" data-id="element-166">
                  {bonus.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}